// `React` must be in SCOPE, not merely resolvable: the kiosk renderchecks run ts-node with
// `"jsx": "react"` (the classic runtime), which compiles this file's JSX to
// `React.createElement`. The app bundlers use the automatic runtime and need no import, so a
// missing one here builds clean and throws only in those node-only gates.
import React from "react";
import Svg, { Path } from "react-native-svg";

/**
 * A `‹` — back controls, and the Previous button on the customiser.
 *
 * The sibling of `ChevronRight`, and it arrived the same way: the designer's export pasted
 * whole into a `.tsx`, which is an `<svg>` element at a module's top level rather than a
 * component, with `stroke="#111C36"` baked in. That ink is right on a white header and wrong on
 * the brand-coloured button Template 1 draws it on, so the colour is the CALLER's — `color` is
 * required, and no default would be correct in both places.
 *
 * The export's `<clipPath>` is dropped, as it is in `ChevronRight`: it clipped to a 24×24 rect
 * through `matrix(0 1 -1 0 24 0)`, a rotation that maps the box onto itself, so it removed
 * nothing from a stroke already inside it — while carrying a document-wide `id` into every
 * instance on the page, which is the usual reason one copy of an SVG icon renders blank.
 */
export function ChevronLeft({
  color,
  size = 24,
  thickness,
}: {
  /** Required — see above. */
  color: string;
  /** Both axes; the source is square. */
  size?: number;
  /**
   * Stroke weight in RENDERED pixels, not viewBox units — the same thing `ChevronLeftGlyph`'s
   * prop of this name meant, so the call sites that set it port across unchanged. Converted
   * here because a stroke inside a scaled viewBox is scaled with it: 2.4 units of a 24-unit box
   * is 1.6px once drawn at 16, which is thinner than a header back-arrow wants.
   */
  thickness?: number;
}) {
  const strokeWidth = thickness === undefined ? 2.4 : thickness * (24 / size);

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M14.9288 3.87019L6.4435 12.3555L14.9288 20.8408"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
ChevronLeft.displayName = "ChevronLeft";
export default ChevronLeft;
